import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";

import Header from "./Header";
import Footer from "./Footer";
import heroImg from "./hero.webp";
import contactImg from "./contact.png";

const PRIMARY_COLOR = "#007bff";
const WHATSAPP_GREEN = "#25D366";

const BUSINESS = {
  name: "Branding Media Factory",
  whatsappNumber: "919600974238", // Formatted for URL (Country Code + Number)
  displayPhone: "+91 96009 74238",
  secondaryPhone: "+91 73737 55589",
  email: "brandingmediafactory@gmail.com",
  address: {
    street: "No 364, 103-C, Narayana Pillai Street",
    area: "Peramanur",
    city: "Salem",
    state: "Tamil Nadu",
    pincode: "636007",
  },
  mapEmbed: "https://www.google.com/maps?q=Branding+Media+Factory+Salem&output=embed",
};

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Construct the WhatsApp Message with formatting
    const text = `*New Inquiry from Website*%0A%0A` +
                 `*Name:* ${encodeURIComponent(form.name)}%0A` +
                 `*Email:* ${encodeURIComponent(form.email)}%0A` +
                 `*Message:* ${encodeURIComponent(form.message)}`;
    
    const whatsappURL = `https://wa.me/${BUSINESS.whatsappNumber}?text=${text}`;

    toast.success("Opening WhatsApp...");

    // GA4 tracking if applicable
    if (window.gtag) {
      window.gtag("event", "generate_lead", {
        method: "WhatsApp",
      });
    }

    // Redirect to WhatsApp
    setTimeout(() => {
        window.open(whatsappURL, "_blank");
    }, 500);
  };

  return (
    <>
      <Helmet>
        <title>Contact BMF | Outdoor & Digital Advertising Chennai</title>
        <meta name="description" content="Contact Branding Media Factory for unipole hoardings, train branding & digital marketing in Tamil Nadu. WhatsApp us at +91 96009 74238 for a free consultation." />
        <meta name="keywords" content="contact Branding Media Factory, BMF contact Chennai, advertising agency contact Salem, unipole hoarding enquiry Tamil Nadu" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact BMF | Outdoor & Digital Advertising Chennai" />
        <meta property="og:description" content="Reach BMF via WhatsApp for instant advertising & branding consultations. Office in Salem, Tamil Nadu. Call +91 96009 74238." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://brandingmediafactory.com/contact" />
      </Helmet>

      <Header />

      <header style={heroHeaderStyle}>
        <div style={overlayStyle} />
        <div style={{ position: "relative", color: "#fff", textAlign: "center" }}>
          <h1 style={{ fontSize: "2.5rem" }}>Let's Chat on WhatsApp</h1>
          <p>Instant Branding & Marketing Consultations</p>
        </div>
      </header>

      <main style={{ background: "#f8f9fa", padding: "4rem 5%" }}>
        <section style={{ maxWidth: "1200px", margin: "auto", display: "flex", flexDirection: "column", gap: "50px" }}>
          
          {/* Top Row: Address & Map */}
          <div className="top-info-block">
            <div style={{ display: "flex", gap: "25px", marginBottom: "25px" }} className="address-map-row">
              <div className="address-card" style={cardStyle}>
                <h3>📍 Our Office</h3>
                <p>
                  <strong>{BUSINESS.name}</strong><br />
                  {BUSINESS.address.street}, {BUSINESS.address.area}<br />
                  {BUSINESS.address.city}, {BUSINESS.address.state} – {BUSINESS.address.pincode}
                </p>
                <p>👤 <strong>Founder:</strong> Xavier</p>
                <p>👤 <strong>Managing Director:</strong> Esther R</p>
                <p>📞 WhatsApp: <a href={`https://wa.me/${BUSINESS.whatsappNumber}`}>{BUSINESS.displayPhone}</a></p>
                <p>📞 Call: <a href={`tel:${BUSINESS.secondaryPhone}`}>{BUSINESS.secondaryPhone}</a></p>
                <p>📧 <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></p>
              </div>

              <div className="map-wrapper" style={{ flex: 1, minWidth: "50%" }}>
                <iframe
                  src={BUSINESS.mapEmbed}
                  title="Google Map Location"
                  loading="lazy"
                  style={iframeStyle}
                ></iframe>
              </div>
            </div>
          </div>
            
          {/* Bottom Row: Image & WhatsApp Form */}
          <div style={{ display: "flex", gap: "50px", alignItems: "stretch" }} className="image-form-row">
            <div style={{ flex: "0 0 40%", display: "flex", alignItems: "center" }}>
                <img src={contactImg} alt="Contact Us" className="floating-image" style={{ width: "100%", borderRadius: "24px" }} />
            </div>

            <div style={formCardStyle} className="contact-form-card">
              <h2>Quick Inquiry</h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  value={form.name}
                  onChange={handleChange}
                  style={inputStyle}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  value={form.email}
                  onChange={handleChange}
                  style={inputStyle}
                />
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Tell us about your project..."
                  required
                  value={form.message}
                  onChange={handleChange}
                  style={{...inputStyle, resize:"none"}}
                />
                <button type="submit" style={whatsappButtonStyle}>
                  Connect on WhatsApp
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <style>{`
        @keyframes floatImage {
          0% { transform: translateY(0); }
          50% { transform: translateY(-14px); }
          100% { transform: translateY(0); }
        }
        .floating-image { animation: floatImage 6s ease-in-out infinite; }
        .address-card a { color: ${PRIMARY_COLOR}; text-decoration:none; font-weight: 600; }
        
        @media (max-width:992px){
            .image-form-row { flex-direction: column; }
            .contact-form-card, .image-form-row > div { flex: 1 1 100% !important; }
        }
        @media (max-width:768px){
            .address-map-row { flex-direction: column; gap: 25px; } 
            .map-wrapper iframe { height: 280px !important; } 
        }
      `}</style>
    </>
  );
};

/* Style Constants */
const heroHeaderStyle = { height: "420px", background: `url(${heroImg}) center/cover no-repeat`, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" };
const overlayStyle = { position: "absolute", inset: 0, background: "rgba(0,0,0,0.6)" };
const cardStyle = { flex: 1, minWidth: "50%", background: "#fff", padding: "25px", borderRadius: "14px", boxShadow: "0 8px 25px rgba(0,0,0,0.08)" };
const iframeStyle = { width: "100%", height: "100%", border: "0", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" };
const formCardStyle = { flex: "1 1 60%", background: "#fff", padding: "35px", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0,0,0,0.08)" };
const inputStyle = { width:"100%", padding:"14px", marginBottom:"16px", borderRadius:"8px", border:"1px solid #ddd", fontSize:"1rem" };
const whatsappButtonStyle = { background: WHATSAPP_GREEN, color:"#fff", padding:"16px", width:"100%", border:"none", borderRadius:"8px", fontSize:"1.1rem", fontWeight: "700", cursor: "pointer", transition: "0.3s opacity" };

export default ContactPage;